export default "__VITE_ASSET__BIjz7OE$__"